import { createAction, props } from '@ngrx/store';
import {
  ICheckOutcomeOverview,
  ICheckOverview,
  IFileOverview,
  ITaskOverview,
  ITaskStats
} from 'src/app/shared/models/tasks-overview.model';

export const ClearState = createAction('[Overview] Clear state');

export const GetAnalysisTasks = createAction(
  '[Overview] Get analysis tasks',
  props<{ projectId: string; analysisId: string }>()
);
export const GetAnalysisTasksSuccess = createAction(
  '[Overview] Get analysis tasks success',
  props<{ tasks: ITaskOverview[]; analysisId: string }>()
);
export const GetAnalysisTasksFailed = createAction('[Overview] Get analysis tasks failed', props<{ payload: Error }>());

export const GetAnalysesFiles = createAction('[Overview] Get analyses files', props<{ projectId: string }>());
export const GetAnalysesFilesSuccess = createAction(
  '[Overview] Get analyses files success',
  props<{ files: { [analysisId: string]: IFileOverview[] } }>()
);
export const GetAnalysesFilesFailed = createAction('[Overview] Get analyses files failed', props<{ payload: Error }>());

export const GetAnalysesTaskStats = createAction('[Overview] Get analyses task stats', props<{ projectId: string }>());
export const GetAnalysesTaskStatsSuccess = createAction(
  '[Overview] Get analyses task stats success',
  props<{ taskStats: { [analysisIndex: string]: ITaskStats } }>()
);
export const GetAnalysesTaskStatsFailed = createAction(
  '[Overview] Get analyses task stats failed',
  props<{ payload: Error }>()
);

export const GetChecks = createAction('[Overview] Get checks');
export const GetChecksSuccess = createAction('[Overview] Get checks success', props<{ checks: ICheckOverview[] }>());
export const GetChecksFailed = createAction('[Overview] Get checks failed', props<{ payload: Error }>());

export const GetAnalysisCheckOutcomes = createAction(
  '[Overview] Get analysis check outcomes',
  props<{ projectId: string; analysisId: string }>()
);
export const GetAnalysisCheckOutcomesSuccess = createAction(
  '[Overview] Get analysis check outcomes success',
  props<{ checkOutcomes: ICheckOutcomeOverview[]; analysisId: string }>()
);
export const GetAnalysisCheckOutcomesFailed = createAction(
  '[Overview] Get analysis check outcomes failed',
  props<{ payload: Error }>()
);
